import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmailService } from '../../services/email.service';

@Component({
  selector: 'app-after-updatepwd',
  templateUrl: './after-updatepwd.component.html',
  styleUrls: ['./after-updatepwd.component.css']
})
export class AfterUpdatepwdComponent implements OnInit {

  email!:string

  constructor(private router:Router,emailsercive:EmailService){

    this.email = emailsercive.getEmail()

  }
  ngOnInit(): void {

      setTimeout(() => {
        this.router.navigateByUrl('/auth/login');

      },10000)
  }

}
